
import { DATE_FORMAT } from '@emobg/web-utils';
import { isMoment } from 'moment';
import { defineComponent } from 'vue';

import { useTranslation } from '@composables/translation';

export default defineComponent({
  name: 'DatePicker',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { locale } = useTranslation();

    const handleChangedDate = (event: CustomEvent) => {
      const isMomentDate = isMoment(event.detail);
      const formattedDate = isMomentDate ? event.detail.format(DATE_FORMAT.date) : event.detail;
      emit('update:date', formattedDate);
    };

    return {
      locale,
      handleChangedDate,
    };
  },
});
